import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['{brandSlug}/{practiceSlug}/labs'],
  validationMode: 'any',
};

export const labsStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.Labs,
  category: PracticeSetupStepCategory.AdditionalSettings,
  title: 'Set Up Labs and Contacts',
  description: initRawSchema(
    `Principle includes dedicated pages for managing your professional contacts and the labs your practice works with. Keeping these up to date ensures your team has quick access to the information they need and allows you to make full use of Principle's lab job tracking functionality.`
  ),
  dependsOn: [],
  getRoute: (brand, practice) => `${brand.slug}/${practice.slug}/labs`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review the labs before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
